module.exports = __webpack_public_path__ + "img/api-flow.875b82c0.png";